const validationPatterns = {
    /* eslint-disable */
    required: /(?!^$)/,
    numeric: /^(0|[1-9][0-9]*)$/,
    mileage: /^\d{0,3}([. ]{0,1}\d{3}){0,2}$/,
    tradeInMileage:
        /* eslint-disable-next-line max-len */
        /^([2-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|[1-8][0-9]{4}|9[0-8][0-9]{3}|99[0-8][0-9]{2}|999[0-8][0-9]|9999[0-9]|[1-3][0-9]{5}|4[0-8][0-9]{4}|49[0-8][0-9]{3}|499[0-8][0-9]{2}|4999[0-8][0-9]|49999[0-9])$/,
    /* eslint-disable-next-line max-len, no-useless-escape */
    phone: /^[+]?[\(]?[0-9]{2,3}[\)]?[\-s.]?[0-9]{3,}[\-s.]?[0-9]{4,6}$/im,
    /* eslint-disable-next-line max-len, no-useless-escape */
    email: /^[a-zA-Z0-9_!#$%&\u2019*+\/=?`\{\|\}~^.\-]{1,64}@([a-zA-Z0-9.\-]+\.)+[a-zA-Z]{2,}$/,
    numberPlate: /^(?!.*[-]{2})[A-Za-z0-9- ]{6,8}$/,
    alphaNumeric: /^[a-zA-ZÀ-ÿ0-9\-. ]*$/,
    date: /^([0-2][0-9]|(3)[0-1])-(((0)[0-9])|((1)[0-2]))-\d{4}$/i,
    partialPostalCode: /^(?:[1-9][0-9]{0,3}|[1-9][0-9]{3}\s?[a-zA-Z]{1,2})$/,
    validatablePostalCodeOrCity: /^(?:[1-9][0-9]{3}[a-zA-Z]{2}|(?![1-9][0-9]{0,3}$|[1-9][0-9]{3}[a-zA-Z]{1,2}$).+)$/
    /* eslint-enable */
};

export default validationPatterns;
